import React, { useState } from "react";
import styles from "./LeadManegement.module.css";
import SaveBtn from "../../../../../../components/Buttons/SaveBtn";
import right from "../../../../../../assets/images/accordion-select.svg";
import LeadManagementConfirmPopup from "./LeadManagementConfirmPopup";
import FinalConfirmPopup from "./FinalConfirmPopup";
import { useNavigate } from "react-router-dom";
import BatchDetailsSkeleton from "../../../../../../components/Skeletons/Batch/BatchDetailsSkeleton";
import deleteIcon from "../../../../../../assets/images/delete-dustbin.svg";
import {
  FormControl,
  FormControlLabel,
  Switch,
  SwitchProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import DeletePopup from "./DeletePopup";
import { resetDeleteSuccess } from "../../../service/LeadAutomationSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  checkSubDomainAccess,
  getSubDomainAccessStatus,
} from "../../../../../../components/RolePermissionAccess/RolePermissionAccess";
const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#23A67B",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const LeadManagement = ({
  savedLeadAutomation,
  ChangeLeadAutomationStatus,
  getSavedLeadAutomationLoading,
  DeleteLeadAutomationConfig,
  deleteLeadAutomationConfigSuccess,
  deleteLeadAutomationConfigLoading,
}: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
  const [deletableId, setDeletabelId] = useState<any>("");
  const dispatch = useDispatch();
  const batchList = useSelector((state: any) => state.batch.batchList);
  const batchListLoading = useSelector(
    (state: any) => state.batch.batchListLoading
  );

  const { userById } = useSelector((state: any) => state.userDetails);

  const leadAutomationAccess = getSubDomainAccessStatus(
    "SETTINGS",
    "LEAD_AUTOMATION",
    "ALL_ACCESS",
    userById?.rolePermission
  );

  const leadAutomationKeys = [
    { id: 0, value: "Automatic contact detection" },
    { id: 1, value: "Lead creation with course assignment" },
    { id: 2, value: "Smart assignee distribution" },
  ];

  const handlePopupYesButton = () => {
    // handleSendRemainders();
    navigate("/app/Settings/LeadAutomation/CreateLeadAutomationForm");
  };

  const handlePopupNoButton = () => {
    setIsOpen(false);
  };

  const mapAutomationToUI = (item: any) => {
    const methodMap: any = {
      ROUND_ROBIN_ASSIGNMENT: "Round Robin Assignment",
      SINGLE_ASSIGNEE: "Single Assignment",
    };
    const filteredBatches = batchList?.filter(
      (d: any) => d?.batchStatus === "UPCOMING" || d?.batchStatus === "ONGOING"
    );
    const batchData = filteredBatches?.find(
      (b: any) => b?.id === item?.batch?.batchId
    );
    // 2️⃣ Determine invalid batch
    const isBatchInvalid =
      batchData?.batchStatus === "UPCOMING" ||
      batchData?.batchStatus === "ONGOING";

    // 3️⃣ UI batch name + warning
    const batchName = batchData?.batchName;

    const batchValue =
      batchName === undefined
        ? isBatchInvalid === false
          ? Object.keys(item?.batch).length === 0
            ? "-"
            : `Batch doesn't exist or is Inactive Please change batch.`
          : batchName
        : batchName;

    return [
      {
        label: "Trigger",
        value:
          item?.trigger === "WEBFORM"
            ? "Webform"
            : item?.trigger === "EXCEL"
            ? "Excel"
            : "Meta" || "-",
      },
      { label: "Source", value: item?.source?.sourceName || "-" },
      { label: "Course", value: item?.course?.courseName || "-" },
      { label: "Branch", value: item?.branch?.branchName || "-" },
      { label: "Batch", value: batchValue, isBatchInvalid },
      {
        label: "Assignment",
        value: `${
          methodMap[item?.assignmentMethod] || item?.assignmentMethod
        } - ${
          item?.assignees?.map((a: any) => a.assigneeName).join(", ") || "-"
        }`,
      },
    ];
  };

  const handleUpdateStatus = (item: any) => {
    const body = {
      ...item,
      status: item?.status === "INACTIVE" ? "ACTIVE" : "INACTIVE",
    };
    ChangeLeadAutomationStatus(body);
  };

  const handleDeleteSubmit = () => {
    DeleteLeadAutomationConfig({ id: deletableId });
    setShowDeletePopup(false);
    dispatch(resetDeleteSuccess());
  };

  const handleOnClose = () => {
    setShowDeletePopup(false);
  };

  return (
    <>
      {batchList === null || getSavedLeadAutomationLoading ? (
        <BatchDetailsSkeleton />
      ) : (
        <div className={styles.leadManagementContainer}>
          <div className={styles.firstSection}>
            <div className={styles.firstSectionHeader}>
              Contacts Automation Setup
            </div>
            <div className={styles.firstSectionSubHeader}>
              Configure automatic contact to lead conversion
            </div>
          </div>
          {savedLeadAutomation?.length <= 0 || savedLeadAutomation === null ? (
            <>
              <div className={styles.secondSection}>
                <div className={styles.secondSectionHeader}>
                  Automation lead Conversion
                </div>
                <div className={styles.secondSectionSubHeader}>
                  When enabled, new contacts will automatically be converted to
                  leads and assigned to your specified courses and team members.
                </div>
                <div>
                  {leadAutomationKeys?.map((item: any) => {
                    return (
                      <div className={styles.keyValueContainer}>
                        <img src={right} />
                        <div className={styles.keyValues}>{item?.value}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                className={styles.thirdSection}
                style={{ marginTop: "10px" }}
              >
                <SaveBtn
                  buttonText={"Setup Auto Lead Creation"}
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  disabled={leadAutomationAccess === false}
                />
              </div>
            </>
          ) : (
            <div className={styles.activContainer}>
              <div className={styles.activContainer}>
                <div className={styles.activContainerHeader}>
                  <div className={styles.activeTitle}>
                    Active Automation Setups
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div className={styles.activeBox}>
                      {
                        savedLeadAutomation?.filter(
                          (d: any) => d?.status === "ACTIVE"
                        ).length
                      }{" "}
                      Active
                    </div>
                    <div
                      className={styles.thirdSection}
                      style={{ marginTop: "10px" }}
                    >
                      <SaveBtn
                        buttonText={"Setup Auto Lead Creation"}
                        onClick={() => {
                          setIsOpen(true);
                        }}
                        disabled={leadAutomationAccess === false}
                      />
                    </div>
                  </div>
                </div>

                {savedLeadAutomation?.map((setup: any, idx: number) => (
                  <div key={setup.id} className={styles.activSubContainer}>
                    <div className={styles.activSubContainerHeader}>
                      <div className={styles.activeTitle}>Setup {idx + 1}</div>

                      {leadAutomationAccess === true && (
                        <div className={styles.editSection}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              marginRight: "8px",
                              cursor: "pointer",
                            }}
                          >
                            <div>
                              {" "}
                              {setup?.status === "ACTIVE"
                                ? "Active"
                                : "In-Active"}
                            </div>
                            <div
                              // className={styles.activeBox}
                              onClick={() => {
                                handleUpdateStatus(setup);
                              }}
                            >
                              <FormControl
                                fullWidth
                                variant="standard"
                                className="formControl"
                                sx={{ width: "auto" }}
                              >
                                <FormControlLabel
                                  style={{
                                    justifyContent: "flex-end",
                                    marginLeft: 0,
                                    color: "#3F3E43",
                                    marginTop: "0px",
                                    // gap: 20,
                                  }}
                                  control={
                                    <IOSSwitch
                                      sx={{ margin: "1px" }}
                                      checked={
                                        setup?.status === "ACTIVE"
                                          ? true
                                          : false
                                      }
                                      id="studentAutoDebit"
                                      onChange={(e) => {
                                        handleUpdateStatus(setup);
                                      }}
                                    />
                                  }
                                  label=""
                                  labelPlacement="start"
                                />
                              </FormControl>
                            </div>
                          </div>

                          <div
                            className={styles.activeBoxEdit}
                            onClick={() =>
                              navigate(
                                `/app/Settings/LeadAutomation/EditLeadAutomationForm?leadAutomationId=${setup?.id}`
                              )
                            }
                          >
                            Edit
                          </div>
                          <div
                            className={styles.activeBoxEdit}
                            onClick={() => {
                              setShowDeletePopup(true);
                              setDeletabelId(setup?.id);
                            }}
                          >
                            <img src={deleteIcon} />
                          </div>
                        </div>
                      )}
                    </div>

                    {mapAutomationToUI(setup).map((field: any, index: any) => (
                      <div
                        key={index}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "160px auto",
                          alignItems: "center",
                          fontSize: "15px",
                          marginBottom: "5px",
                        }}
                      >
                        <div
                          style={{
                            color: "rgba(20, 44, 68, 1)",
                            fontWeight: 500,
                          }}
                        >
                          {field.label}
                        </div>
                        <div
                          style={{
                            color:
                              field?.value !== "-" &&
                              field?.isBatchInvalid === false
                                ? "red"
                                : "rgba(102, 112, 133, 1)",
                            fontWeight: 400,
                            textTransform: "capitalize",
                          }}
                        >
                          : {field.value}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      <LeadManagementConfirmPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        handlePopupYesButton={handlePopupYesButton}
        handlePopupNoButton={handlePopupNoButton}
      />
      {/* <FinalConfirmPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        handlePopupYesButton={handlePopupYesButton}
        handlePopupNoButton={handlePopupNoButton}
      /> */}
      <DeletePopup
        isOpen={showDeletePopup}
        onClose={handleOnClose}
        yesBtnClick={handleDeleteSubmit}
        agentAddedLoading={deleteLeadAutomationConfigLoading}
      />
    </>
  );
};

export default LeadManagement;
